import { theme } from '@febos-io/design';

import useTranslation from '../hooks/useTranslation';
import { useAuthContext } from '../providers';

export function ChangePasswordPage() {
  const { t } = useTranslation();
  const {
    ChangePasswordForm
  } = useAuthContext();
  return (
    <theme.views.Login>
      <strong>{t('Reset Password')}</strong>
      <ChangePasswordForm />
    </theme.views.Login>
  );
}

export default ChangePasswordPage;
